import { OpenAIProvider } from './providers/openaiProvider.js';
import { AnthropicProvider } from './providers/anthropicProvider.js';

export class LLMClient {
  constructor(config) {
    this.provider = this.createProvider(config);
  }

  createProvider(config) {
    switch (config.provider) {
      case 'anthropic':
        return new AnthropicProvider(config);
      case 'qwen':
      case 'deepseek':
      case 'openai':
      default:
        return new OpenAIProvider(config);
    }
  }

  async send(messages, { responseFormat } = {}) {
    const maxRetries = 2;
    let lastError;

    for (let i = 0; i <= maxRetries; i++) {
      try {
        return await this.provider.send(messages, { responseFormat });
      } catch (err) {
        lastError = err;
        if (!this.isRetryable(err) || i === maxRetries) {
          throw err;
        }
        await this.delay(1000 * (i + 1));
      }
    }

    throw lastError;
  }

  isRetryable(err) {
    return err.name === 'TypeError' || err.code === 'TIMEOUT' || (err.status && err.status >= 500);
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
